import { api, setConfig } from '../..';
import { mapEntityToApi, mapApiToEntity } from './mapper';
import { PropertyType } from '../../../common';

export const getCasinoGameCategory = (data: PropertyType): Promise<PropertyType> =>
	api.post(`games/categories/show`, mapEntityToApi(data), setConfig(data)).then((res) => {
		return mapApiToEntity(res.data);
	});
